import React, {useEffect} from 'react'
import styled from 'styled-components'
import { useObserver } from 'mobx-react'
import { Alert, Spinner } from 'react-bootstrap'
import useStores from '../../../stores/useStore'
import StoreReturnSubheader from '../../../components/LocalReturns/StoreReturns/StoreReturnSubheader'
import StoreReturnSidebar from '../../../components/LocalReturns/StoreReturns/StoreReturnSidebar'
import StoreReturnContentArea from '../../../components/LocalReturns/StoreReturns/StoreReturnContentArea'
import { StyledGoodReceiptsContainer } from '../../../components/LocalReceipts/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import LocalReturnDataProvider, { useLocalReturnDataState } from '../../../stores/LocalReturnDataProvider'
import { useParams } from 'react-router-dom'

const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`
const StoreReturnPageContent = () => {
    const { returnId } = useParams()
    const { loadReturnData } = useLocalReturnDataState()
    
    useEffect(() => {
      const init = async () => {
        loadReturnData(returnId, 'store')
      }
      init()
    }, [returnId, loadReturnData])
  
    return (
        <>
        <StoreReturnSubheader />
        <FlexWrapper>
          <StyledContentArea>
            <StoreReturnContentArea />
          </StyledContentArea>
          <TestSidebarRight>
            <StoreReturnSidebar />
          </TestSidebarRight>
        </FlexWrapper>
        <BigFooter />
      </>
    )
  }
  
  const StoreReturnPage = () => {
    const { uiStore } = useStores()
    const { t } = useTranslation()
    const dashboardLoaded = useObserver(() => !!uiStore.dashboard)
  
  
    return useObserver(() => (
      <LocalReturnDataProvider>
        <StyledGoodReceiptsContainer>
          {!dashboardLoaded || !uiStore.isLocalStorageAdmin
            ? (
              <FlexWrapper>
                <StyledContentArea>
                  {dashboardLoaded
                    ? <Alert variant="danger">{t('goodsReceiptPage:storeReceiptAlert')}</Alert>
                    : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
                  }
                </StyledContentArea>
                <TestSidebarRight>
                </TestSidebarRight>
              </FlexWrapper>)
            :
            <StoreReturnPageContent />
          }
          <BigFooter />
        </StyledGoodReceiptsContainer>
      </LocalReturnDataProvider>
    ))
  }
  
  export default StoreReturnPage
  